<div mat-dialog-content>
	<div [style.height.px]="containerHeight" [style.width.px]="containerWidth" class="flex_center">
		<image-cropper
			[imageChangedEvent]="imageChangedEvent"
			format="webp"
			(imageCropped)="imageCropped($event)"

			[aspectRatio]="minHeight/minWidth"
			[maintainAspectRatio]="keepAspectRatio"
			[cropperMinWidth]="minWidth"
			[cropperMinHeight]="minHeight"
			[roundCropper]="rounded"
			[resizeToWidth]="resizeToMinimumWidth ? resizeToMinimumWidth : 0"
			alignImage="center"
		></image-cropper>
	</div>
</div>
<div mat-dialog-actions align="end" class="padding_top_medium">
	<button mat-button color="primary" class="" mat-dialog-close>Cancelar</button>		
	<button mat-flat-button color="primary" class="" (click)="accept()">Aceptar</button>		
</div>